import { useEffect, useState } from 'react';
import { auth } from '../firebaseConfig';
import { verifyAdminSession } from '../utils/adminSessionClient';

export default function useAdminSession(wallet) {
    const uid = wallet.publicKey?.toBase58?.() || '';
    const connected = !!wallet.connected;
    const [observed, setObserved] = useState({ user: null, version: 0, ready: false });
    const [verification, setVerification] = useState(null);
    const [refresh, setRefresh] = useState(0);

    useEffect(() => auth.onIdTokenChanged(user => {
        setObserved(previous => ({ user, version: previous.version + 1, ready: true }));
    }), []);

    useEffect(() => {
        let current = true;
        setVerification(null);
        const user = observed.user;
        if (connected && uid && user?.uid === uid && auth.currentUser === user) {
            verifyAdminSession(user).then(() => {
                if (current && auth.currentUser === user) setVerification({ user, uid, version: observed.version, status: 'authorized' });
            }).catch(error => {
                if (!current || auth.currentUser !== user) return;
                const code = error.code || '';
                const status = ['admin/signature-required', 'functions/unauthenticated', 'auth/user-token-expired', 'auth/invalid-user-token'].includes(code)
                    ? 'sign_in' : code === 'functions/permission-denied' ? 'denied' : 'error';
                setVerification({ user, uid, version: observed.version, status,
                    error: status === 'error' ? error.message || 'Admin access could not be verified. Please retry.' : '' });
            });
        }
        return () => { current = false; };
    }, [connected, uid, observed, refresh]);

    let status = 'checking';
    if (!connected || !uid) status = 'connect';
    else if (!observed.ready) status = 'checking';
    else if (!observed.user || auth.currentUser !== observed.user || observed.user.uid !== uid) status = 'sign_in';
    else if (verification?.user === observed.user && verification.uid === uid && verification.version === observed.version) status = verification.status;
    return { authorized: status === 'authorized', status, uid, version: observed.version,
        error: status === 'error' ? verification.error : '', retry: () => setRefresh(value => value + 1) };
}
